<h1 mat-dialog-title>We are unable to access your media recorder</h1>
<button mat-button mat-dialog-close class="close">
    <span class="material-icons">
        close
    </span>
    Close
</button>
<div mat-dialog-content>
    <div class="container-box">
        <p>You are unable to Record the Calls, because you media recorder is not Enabled. Please follow the below steps
            to enable it:</p>
        <div class="access-modal-content">
            <div class="access-section-info reverse-info">
                <div class="access-info-msg">
                    <h3>For macOS:</h3>
                    <p>1. Go to Safari → Preferences → Advanced</p>
                    <p>2. Enable the option to “Show Develop menu in menu bar” at the bottom</p>
                </div>
                <div class="access-img">
                    <img src="assets/images/media-recorder-1.png" alt="video conference icon">
                </div>
            </div>
        </div>

        <div class="access-section-info">

            <div class="access-img">
                <img src="assets/images/media-recorder-2.png" alt="allowed access icon">
            </div>
            <div class="access-info-msg">
                <p>3. Go to Develop → Experimental Features</p>
                <p>4. Enable MediaRecorder</p>
            </div>
        </div>

        <div class="access-section-info reverse-info">

            <div class="access-info-msg">
                <h3>For iOS:</h3>
                <p>1. Go to Settings → Safari → Advanced → Experimental Features</p>
                <p>2. Enable MediaRecorder</p>
            </div>
            <div class="access-img">
                <img src="assets/images/media-recorder-3.jpg" alt="video call icon">
            </div>
        </div>
    </div>
</div>